import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';
import { useAuth } from './AuthContext';

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);
    const { user, isAuthenticated } = useAuth();

    useEffect(() => {
        if (isAuthenticated && user) {
            // Connect to socket server
            // In development, the backend runs on port 2222
            const socketUrl = process.env.REACT_APP_API_BASE_URL
                ? process.env.REACT_APP_API_BASE_URL.replace('/api', '')
                : window.location.origin.replace(':3000', ':2222'); // Fallback to same host but port 2222


            const newSocket = io(socketUrl, {
                transports: ['websocket'],
                upgrade: false
            });

            newSocket.on('connect', () => {
                // Join personal room after login using User ID
                const userId = user.id || user._id;
                newSocket.emit('join', `user-${userId}`);
            });


            setSocket(newSocket);

            return () => {
                newSocket.disconnect();
            };
        } else {
            if (socket) {
                socket.disconnect();
                setSocket(null);
            }
        }
    }, [isAuthenticated, user]);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};
